export default class PublicPaymentLinkDomain {
  url: string;

  constructor(url: string) {
    this.url = url;
  }
}
